import { useEffect, useState } from "react";
import api from "../services/api";

// Devis livraison calculé par le serveur (Boxtal > livraison offerte > tarif fixe). null si invité / indisponible.
export const useShippingQuote = (user, items, channel = "perso", refreshKey = 0) => {
  const [quote, setQuote] = useState(null);
  const key = items.map((i) => `${i.id}:${i.qty}`).join("|");
  useEffect(() => {
    if (!user || !items.length) { setQuote(null); return; }
    let alive = true;
    api.get("/cart", { params: { channel } }).then(({ data }) => { if (alive) setQuote(data.shipping_quote || null); }).catch(() => { if (alive) setQuote(null); });
    return () => { alive = false; };
  }, [user, key, channel, refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps
  return quote;
};

export const shippingLabel = (shipping, quote) => {
  if (quote && quote.method === "boxtal" && quote.price == null) return quote.status === "choose" || quote.status === "choose_point" ? "À choisir ci-dessous" : "Indisponible";
  return shipping === 0 ? "Offerte" : `${(shipping || 0).toFixed(2).replace(".", ",")} €`;
};

export const ShippingQuoteNote = ({ quote }) => {
  if (quote && quote.method === "boxtal" && quote.price != null) return <div className="text-[12px] text-slate-400" data-testid="cart-shipping-quote">{quote.carrier} · {quote.label}{quote.pickup_point ? ` · ${quote.pickup_point.name}` : ""}</div>;
  return null;
};
